import exponent from "./exponent";

export default function(step) {
  return Math.max(0, -exponent(Math.abs(step)));
}



//////////////////
// WEBPACK FOOTER
// /Users/sharvil/Desktop/fall17/adaptive/assign1/~/d3-format/src/precisionFixed.js
// module id = ../../../../d3-format/src/precisionFixed.js
// module chunks = 3